<template>
    <div class="latest-news">
        <div class="headline">
          <h1>{{$t("news.latestNews.headlineTitle")}}</h1>
          <p>{{$t("news.latestNews.headlineP")}}</p>
        </div>
        <div class="news-top">
          <el-row :gutter="40" data-swiper-parallax="-300" data-swiper-parallax-duration="1000">
            <el-col :span="18">
              <div  class="new-des" @click="toDetail(newsInfo)">
                <img :src="newsInfo.mainPicUrl" alt />
                <div class="mark">
                  <h2>{{ newsInfo.title }}</h2>
                  <p>{{ newsInfo.createTime }}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <ul class="lists">
                <li
                  v-for="(item,index) in topNews"
                  :key="index"
                  @click="toDetail(item)"
                  @mouseover="getTopNewsIndex(index)"
                  class="list"
                >
                  <img :src="item.mainPicUrl" alt class="pic" />
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="40" class="news-lists">
          <el-col :span="8" :xs="24" v-for="(item,index) in tabLists" :key="index">
            <div class="pic-wrap" @click="toDetail(item)">
              <div class="pic">
                <img :src="item.mainPicUrl" />
              </div>
              <div class="des-row">
                <p>{{item.createTime}}</p>
                <p>{{item.title}}</p>
                <p>{{$t("news.parameter.read")}}</p>
              </div>
              <div class="mark">
                <p>{{item.createTime}}</p>
                <p>{{item.title}}</p>
                <p>{{$t("news.parameter.read")}}</p>
              </div>
            </div>
          </el-col>
        </el-row>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pageReq.page"
          :limit.sync="pageReq.size"
          :pageSizes="[9,12,15]"
          @pagination="getList"
        />


    </div>
</template>
<script>
import {gettopnewlist,getnewlist} from "../../api/news"
import { mapGetters } from "vuex";
export default {
    data(){
        return {
            newsInfo: {},
            total: 0,// 总条数
            pageReq: {
              page: 1,
              size: 9,
            },
            topNews:[],
            tabLists:[],
        }
    },
    // props: {
    //   topNews: {
    //     type: Array,
    //     default: () => [],
    //   },
    //   tabLists: {
    //     type: Array,
    //     default: () => [],
    //   },
    // },
    mounted(){
      // 首页新闻
      gettopnewlist(this.language).then(res =>{
        this.topNews=res.data
        this.newsInfo = res.data[0];
      });
      this.getList();
      
    },
    computed:{
      ...mapGetters(['language'])
    },
    methods:{
      
      // 新闻列表
      getList(){
        const pageReq = {...this.pageReq};
        pageReq.page -= 1;

        getnewlist(this.language,{contentType:'1'},pageReq).then(res =>{
          const { content, totalElements } = res;
          this.tabLists = content;
          this.total = totalElements;
        })
      },
      getTopNewsIndex(index) {
        
          this.newsInfo = this.topNews[index];
      },
      
      toDetail(item) {
       
        if(item.wxUrl){
          window.open(item.wxUrl,false);
        }else{
          this.$router.push({ path: `/news/detail/${item.id}` });
        }
      }
    }
}
</script>
<style lang="scss" scoped>
$cblue: #0054a7;
    .latest-news {
      .news-top {
        margin-bottom:60px;
        .new-des {
          position: relative;
          img {
            height: 580px;
            width: 100%;
            object-fit: cover;
            border-radius: 20px;
          }
          .mark {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            box-sizing: border-box;
            padding: 15px;
            border-radius: 0 0 20px 20px;
            h2{
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
        .lists {
          height: 580px;
          overflow: hidden;
          box-sizing: border-box;
          .list {
            margin-bottom: 20px;
            .pic {
              height: 180px;
              width: 100%;
              object-fit: cover;
              border-radius: 20px;
            }
          }
        }
      }
      .news-lists {
        .pic-wrap {
          margin-bottom: 20px;
          position: relative;
          &:hover {
            .mark {
              cursor: pointer;
              display: block;
            }
          }
          .pic {
            height: 240px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 22px;
              object-fit: cover;
            }
          }
          .des-row {
            padding: 15px;
            p:nth-of-type(1) {
              color: $cblue;
            }
            p:nth-of-type(2) {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 64px;
            }
            p:nth-of-type(3) {
              color: $cblue;
            }
          }
          .mark {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: #fff;
            padding: 20px;
            box-sizing: border-box;
            background: rgba(9, 85, 161, 0.9);
            border-radius: 22px;
            display: none;
            p:nth-of-type(2) {
              padding: 30px 0;
              overflow: hidden;
            }
          }
        }
      }
      @media screen and (max-width:768px){
        .news-top {
          margin-bottom:40px;
          .new-des {
            position: relative;
            img {
              height: 220px;
              width: 100%;
              object-fit: cover;
              border-radius: 10px;
            }
            .mark {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              background: rgba(0, 0, 0, 0.4);
              color: #fff;
              box-sizing: border-box;
              padding: 15px;
              border-radius: 0 0 10px 10px;
              h2{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
          .lists {
            height: 220px;
            overflow: hidden;
            box-sizing: border-box;
            margin-left:-20px;
            .list {
              margin-bottom: 20px;
              .pic {
                height: 60px;
                width: 100%;
                object-fit: cover;
                border-radius: 10px;
              }
            }
          }
        }
        .news-lists {
          .pic-wrap {
            margin-bottom: 20px;
            position: relative;
            &:hover {
              .mark {
                cursor: pointer;
                display: block;
              }
            }
            .pic {
              height: 240px;
              img {
                width: 100%;
                height: 100%;
                border-radius: 22px;
                object-fit: cover;
              }
            }
            .des-row {
              padding: 15px;
              p:nth-of-type(1) {
                color: $cblue;
              }
              p:nth-of-type(2) {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: normal;
                overflow: normal;
                text-overflow: ellipsis;
                height: auto;
              }
            }
          }
        }
      }
    }
</style>